import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import SiteLayout from "@/components/site/SiteLayout";
import HeroesBubble from "@/components/site/HeroesBubble";
import Home from "@/pages/Home";
import Scooters from "@/pages/Scooters";
import ScooterDetail from "@/pages/ScooterDetail";
import DeliveryArea from "@/pages/DeliveryArea";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import RentalPolicies from "@/pages/RentalPolicies";
import PortCanaveralConcierge from "@/pages/PortCanaveralConcierge";
import HeroesDiscount from "@/pages/HeroesDiscount";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/scooters" element={<Scooters />} />
                        <Route path="/scooters/:id" element={<ScooterDetail />} />
                        <Route path="/delivery-area" element={<DeliveryArea />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/rental-policies" element={<RentalPolicies />} />
                        <Route
                            path="/port-canaveral-cruise-scooter-rental"
                            element={<PortCanaveralConcierge />}
                        />
                        <Route
                            path="/heroes-discount"
                            element={<HeroesDiscount />}
                        />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
                <HeroesBubble />
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
